import dayjs from 'dayjs';

// Use the same business date as the database, including around UTC midnight.
export const signatureDateToday = (): string => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const part = (type: string) =>
    parts.find((item) => item.type === type)!.value;
  return `${part('year')}-${part('month')}-${part('day')}`;
};

export const signatureDateValidationError = (
  value: string | null | undefined,
  required = true
): string | undefined => {
  if (!value)
    return required
      ? 'A saved signature date is required to mark this SVA complete.'
      : undefined;
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(value) ||
    !dayjs(value).isValid() ||
    dayjs(value).format('YYYY-MM-DD') !== value
  )
    return 'Enter a valid signature date.';
  if (value > signatureDateToday())
    return 'The signature date cannot be in the future.';
  return undefined;
};
